/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {
    AfterContentChecked,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    OnDestroy,
    OnInit
} from '@angular/core';
import { DeviceService } from '../../shared/services/device.service';
import { DataReportCollection } from '../state/report.model';
import { LoggerService } from '../../shared/services/logger.service';
import { QueryService } from '../../map/services/query.service';
import { Observable } from 'rxjs';
import { MapConfigService } from '../../map/services/mapConfig.service';
import { RedlineConfigService } from '../../../components/redline/services/redline-config.service';
import { MatDialog } from '@angular/material/dialog';
import { Actions, Select, Store } from '@ngxs/store';
import { ReportDisplayOverlayRef } from './report-display.overlay-ref';
import { ReportState } from '../state/report.state';
import { ReportDisplayBaseComponent } from './report-display-base.component';
import { takeUntil } from 'rxjs/operators';
import { RestoreSnapshot } from '../../../ngxs/snapshotPlugin/ngxs-snapshot.actions';
import { ReportService } from '../services/report.service';

@Component({
    selector: 'dash-gis-report-display',
    templateUrl: './data-report-display.component.html',
    styleUrls: [ './data-report-display.component.scss' ],
    providers: [ ReportDisplayBaseComponent ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataReportDisplayComponent
    extends ReportDisplayBaseComponent
    implements OnInit, AfterContentChecked, OnDestroy {

    @Select(ReportState.dataReports)  dataReports$: Observable<DataReportCollection>;
    @Select(ReportState.activeDataReports) activeDataReports$: Observable<DataReportCollection>;

    protected historyGroup = 'dataReports';

    constructor(
        logger: LoggerService,
        mapConfig: MapConfigService,
        redlineConfig: RedlineConfigService,
        reportService: ReportService,
        queryService: QueryService,
        deviceService: DeviceService,
        dialog: MatDialog,
        actions$: Actions,
        store: Store,
        cdr: ChangeDetectorRef,
        @Inject(ReportDisplayOverlayRef) overlayRef: ReportDisplayOverlayRef,
    ) {
        super(
            logger, mapConfig, redlineConfig, reportService,
            queryService, deviceService, dialog,
            actions$, store, cdr, overlayRef
        );
    }

    ngOnInit() {
        super.ngOnInit();

        this.activeDataReports$.pipe(
            takeUntil(this.dispose$),
        ).subscribe((reports) => {
            if (reports.length === 0) {
                this.closePanel.emit();
            }
        });
    }

    ngAfterContentChecked() {
        super.ngAfterContentChecked();
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    public historyBack() {
        this.store.dispatch(new RestoreSnapshot({group: 'dataReports'}));
    }

}
